import React from 'react';
import { useSearchParams } from 'react-router-dom';

import useNemo from '../../api/useNemo';
import { Layout } from '../../components/layout/layout';
import { parseJWT } from '../../utils/jwt';
import EcoSection from '../sections/eco/eco-section';
import { GrowthSection } from '../sections/growth/growth-section';
import { GenerateReport } from '../sections/intro/generate-report/generate-report';
import { IntoSection } from '../sections/intro/intro';
import SecuritySection from '../sections/security/security-section';
import SpeedSection from '../sections/speed/speed-section';
import { SupportSection } from '../sections/support/support';
import ThankYouSection from '../sections/thank-you/thank-you-section';

export const General: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('utm_source') || searchParams.get('token');

  const hasValidToken = parseJWT(token);
  const [data, setData] = React.useState([]);

  const request = useNemo();

  React.useEffect(() => {
    if (!parseJWT(token)) {
      return;
    }

    request({
      endpoint: `/sites?_client_token=${token}`,
      method: 'GET'
    }).then(({ data }) => setData(data));
  }, [token, request]);

  return (
    <Layout>
      <IntoSection>{hasValidToken && <GenerateReport token={token} domains={data} />}</IntoSection>

      <SpeedSection />

      <SecuritySection />

      <GrowthSection />

      <EcoSection />

      <SupportSection />

      <ThankYouSection hideSignupForm={hasValidToken} />
    </Layout>
  );
};
